export default __webpack_public_path__ + "img-torre.97e8384.svg";